<template>
    <section id="featserv" class="section">
        <div class="container" id="ftservcontainer">
            <p class="f-featserv-title">
                <img style="height:1.5rem;" align="bottom" src="/static/images/feat_services/estrela2.png" alt="">&nbsp;
                {{title}}
            </p>
            <div class="swiper-container-featproj">
                <div class="swiper-wrapper">
                    <div v-for="slide in slides" class="swiper-slide">
                        <div class="f-featserv-slide">
                            <span class="">
                                <a @click="selectService(cards[((slide-1)*3)+0].service)">
                                    <img class="f-featserv-slidecard" :src="cards[((slide-1)*3)+0].image">
                                </a>
                            </span>
                            <span class="" v-if="cards[((slide-1)*3)+1]">
                                <a @click="selectService(cards[((slide-1)*3)+1].service)">
                                    <img class="f-featserv-slidecard" :src="cards[((slide-1)*3)+1].image">
                                </a>
                            </span>
                            <span class="" v-if="cards[((slide-1)*3)+2]">
                                <a @click="selectService(cards[((slide-1)*3)+2].service)">
                                    <img class="f-featserv-slidecard" :src="cards[((slide-1)*3)+2].image">
                                </a>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="swiper-button-prev"></div>
                <div class="swiper-button-next"></div>
            </div>
         </div>
    </section>
</template>

<script>
//import Swiper from 'swiper';
import { all } from "../plugins/serviceList";

export default {
  props: ["title", "cards"],

  data() {
    return {
      services: all
    };
  },
  computed: {
    slides() {
      return Math.ceil(this.cards.length / 3);
    }
  },
  mounted() {
    let swiper = new Swiper(".swiper-container-featproj", {
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      }
    });
  },
  methods: {
    selectService(s_id) {
      let srv = this.services.filter(s => {
        return s.id === s_id;
      })[0];
      this.$emit("setParentService", srv);
      this.$emit("openOrderModal");
    }
  }
};
</script>
<style scoped lang="scss">
$info: #2d3256;

$slide-width: 18rem;
$slide-height: $slide-width * 0.75;

.container {
  overflow: hidden;
}

.section {
  background-color: white;
}

.f-featserv-slide {
  text-align: center;
  position: relative;
}

.column {
  margin: 1rem;
  flex: unset;
  padding-left: 0;
  padding-right: 0;
  //margin-left: 0;
  // margin-right: 0;
}

#featserv {
  padding: 1rem 1.5rem;
}

.f-featserv-title {
  display: inline;
  font-size: 1.5rem;
  font-weight: 800;
  color: $info;
  margin-left: 2.5rem;
}

.swiper-button-next {
  background-image: url("/static/images/layout/right.svg") !important;
}

.swiper-button-prev {
  background-image: url("/static/images/layout/left.svg") !important;
}

.swiper-slide-next {
  visibility: hidden;
}

.swiper-button-next {
  position: absolute;
  top: 55%;
}
.swiper-button-prev {
  position: absolute;
  top: 55%;
}
.swiper-container-featproj {
  margin-top: 1rem;
}

img {
  max-width: 30%;
}

/* .f-featserv-slidecard{
        min-width:$slide-width;
        min-height: $slide-height;
        background-position: center;
        background-size: contain;
    }*/

@media only screen and (min-width: 1408px) {
  .f-featserv-slidecard {
    min-width: $slide-width;
    min-height: $slide-height;
  }
}
@media only screen and (min-width: 1216px) and (max-width: 1407px) {
  .f-featserv-slidecard {
    min-width: $slide-width;
    min-height: $slide-height;
  }
}
@media only screen and (min-width: 1024px) and (max-width: 1215px) {
  .f-featserv-slidecard {
    min-width: $slide-width * 0.9;
    min-height: $slide-height * 0.9;
  }
}
@media only screen and (min-width: 769px) and (max-width: 1023px) {
  .f-featserv-slidecard {
    min-width: $slide-width * 0.9;
    min-height: $slide-height * 0.9;
  }
}
@media only screen and (max-width: 768px) {
  .f-featserv-slidecard {
    min-width: $slide-width * 0.8;
    min-height: $slide-height * 0.8;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FeatServices.vue